export default {
      id: "catscale-usage",
      viewBox: "0 0 28 32",
      url: __webpack_public_path__ + "img/icons.svg#catscale",
      toString: function () {
        return this.url;
      }
    }